import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

// 挂账列表
export function getReserveListAPI(params) {
  return http({
    url: "/admin/finance/order/reserve/page",
    method: "get",
    params,
  });
}

// 新增挂账
export function addReserveAPI(data) {
  return http({
    url: "/admin/finance/order/reserve/add",
    method: "post",
    data,
  });
}

// 订单信息
export function getOrderInfoAPI(params) {
  return http({
    url: "/admin/order/info",
    method: "get",
    params,
  });
}

// 挂账列表导出
export function exportReserveAPI(data) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/finance/order/reserve/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then(async (res) => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      let filename = `果冻租挂账列表${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch((error) => {
      hideScreenLoading();
      console.log(error);
    });
}
